'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var indicatorMap = exports.indicatorMap = {
  success: true,
  error: true,
  info: true,
  warning: true
};

var sizeAliases = exports.sizeAliases = {
  xlarge: 'xl',
  large: 'l',
  small: 's',
  xsmall: 'xs'
};